import React from 'react'
import { Field } from 'react-final-form'
import ReCaptcha from 'react-google-recaptcha'
import { useSelector } from 'react-redux'

import { getGoogleRecaptchaSiteKey } from '../../redux/config'

type Props = {
  name: string
}

export const CaptchaField = React.forwardRef<ReCaptcha, Props>(({ name }, ref) => {
  const siteKey = useSelector(getGoogleRecaptchaSiteKey)

  return (
    <Field
      name={name}
      render={p => <ReCaptcha ref={ref} size="normal" sitekey={siteKey} onChange={p.input.onChange} />}
    />
  )
})

CaptchaField.displayName = 'CaptchaField'
